import { LitElement, type PropertyValues } from 'lit';

export class FormControl extends LitElement {
	#form?: HTMLFormElement | null;

	static override get properties() {
		return {
			// assignedForm to prevent naming conflict with the internal form reference
			assignedForm: { type: String, attribute: 'form' },
		};
	}

	/**
	 * Form element to which this control is associated
	 */
	declare assignedForm?: string;

	get form() {
		return this.#form;
	}

	protected override updated(changedProperties: PropertyValues<this>): void {
		super.updated(changedProperties);

		if (changedProperties.has('form') || this.#form == null) {
			this.#getAssignedForm();
		}
	}

	#getAssignedForm = () => {
		if (this.hasAttribute('form')) {
			const doc = this.getRootNode() as Document | ShadowRoot;
			const formId = this.getAttribute('form')!;

			this.#form = doc.getElementById(formId) as HTMLFormElement;
		} else {
			// Fall back to the closest containing form
			this.#form = this.closest('form');
		}
	};
}

export default FormControl;
